var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 5.625C21.3309 5.625 15.8941 7.877 11.8855 11.8856C7.87688 15.8942 5.62488 21.331 5.62488 27C5.62488 32.669 7.87688 38.1058 11.8855 42.1144C15.8941 46.123 21.3309 48.375 26.9999 48.375C32.6689 48.375 38.1057 46.123 42.1143 42.1144C46.1229 38.1058 48.3749 32.669 48.3749 27C48.3749 21.331 46.1229 15.8942 42.1143 11.8856C38.1057 7.877 32.6689 5.625 26.9999 5.625Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8937 32.6648H35.4253L36.2938 27.0454H29.8925V23.9741C29.8925 21.6398 30.6553 19.5698 32.8389 19.5698H36.3478V14.6659C35.7313 14.5826 34.4274 14.4004 31.9637 14.4004C26.819 14.4004 23.8029 17.1173 23.8029 23.307V27.0454H18.5143V32.6648H23.8029V48.1099C24.8503 48.2674 25.9112 48.3743 27.0002 48.3743C27.9845 48.3743 28.9453 48.2843 29.8937 48.156V32.6648Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f8dca899692708c59d0d656706dc0c9e.svg";
export { ForwardRef as ReactComponent };